import { useEffect, useState } from "react";
import { FaCheckCircle } from 'react-icons/fa';


const PasoProgressBar = ({ estado }) => {
  const [step, setStep] = useState(1);

  useEffect(() => {
    const timer = setTimeout(() => setStep(2), 1000); // simula avance al paso 2
    const timer2 = setTimeout(() => setStep(3), 3000); // simula avance al paso 3

    return () => {
      clearTimeout(timer);
      clearTimeout(timer2);
    };
  }, []);

  const pasos = [
    { id: 1, label: "Detalles de Cliente" },
    { id: 2, label: "Detalles del Pago" },
    { id: 3, label: "Confirmar Compra" },
  ];

  return (
    <div className="progress-steps-container">
      {pasos.map((paso, index) => (
        <div className="step" key={paso.id}>
          <div
            className={`circle ${step >= paso.id ? "active" : ""} ${
              estado === "Aceptada" && paso.id === 3 ? "check" : ""
            }`}
          >
            {step > paso.id || (estado === "Aceptada" && paso.id === 3) ? (
              <FaCheckCircle />
            ) : (
              paso.id
            )}
          </div>
          <p>{paso.label}</p>
          {index < pasos.length - 1 && <div className="bar" />}
        </div>
      ))}
    </div>
  );
};

export default PasoProgressBar;
